module.exports = __webpack_public_path__ + "img/arrow-right-icon.3f1183c3.png";